import * as Yup from "yup";
import {
  fullName,
  noSpaces,
  limitWords,
  username,
  password,
  noEndlessSpaces,
  latinWithNumbers,
  noSpaceAtTheBeginning,
} from "./regex";

const values = {
  fullName: Yup.string()
    .required("Name is required")
    .matches(fullName, "Name should include only latin symbols")
    .matches(limitWords, "Your name shoud consist of Name and Surname")
    .matches(
      noEndlessSpaces,
      "Only one space character is allowed between words"
    )
    .max(25, "Must be 25 characters or less")
    .min(6, "Your name cannot be less than 6 characters"),
  userName: Yup.string()
    .min(6, "Username cannot be less than 6 letters")
    .matches(username, "Only latin symbols, numbers and '_' are allowed")
    .max(15, "Must be 15 characters or less")
    .required("Please enter your username"),
  email: Yup.string()
    .email("Invalid email address")
    .required("Please enter email"),
  password: Yup.string()
    .matches(password, "The password should include latin letters and numbers")
    .matches(noSpaces, "The password shouldn't inlcude spaces")
    .min(8, "Paswword cannot be less than 8 characters")
    .max(20, "Must be 20 characters or less")
    .required("Password Is Required"),
  confirmPassword: Yup.string()
    .required("Please confirm your password")
    .oneOf([Yup.ref("password"), null], "Passwords must match"),
  newEmail: Yup.string().email("Invalid email address"),
  bio: Yup.string().max(200, "Bio cannot be more than 200 characters"),
  postText: Yup.string().max(10000, "Description is too large"),
  othersInput: Yup.string()
    .max(20, "Category name cannot be more than 20 characters")
    .min(3, "Category name cannot be less than 3 characters")
    .matches(latinWithNumbers, "Invalid category name")
    .matches(
      noEndlessSpaces,
      "Only one space character is allowed between words"
    ),
  commentText: Yup.string().max(
    200,
    "Comment cannot be more than 200 characters"
  ),
  addsName: Yup.string()
    .max(70, "Ads title cannot be more than 70 characters")
    .matches(latinWithNumbers, "Invalid ads title")
    .matches(noSpaceAtTheBeginning, "Title cannot start with space character")
    .required("Ads title is required"),
  addsDescription: Yup.string()
    .matches(
      noSpaceAtTheBeginning,
      "Description cannot start with space character"
    )
    .required("Ad description is required")
    .max(1500, "Ads description cannot be more than 1500 characters"),
  addsUrl: Yup.string().url("Invalid url adress"),
  violationCategory: Yup.string()
    .required("Please enter name of category")
    .min(3, "Category name cannot be less than 3 characters")
    .matches(noEndlessSpaces, "No endless spaces allowed")
    .max(30, "Category name cannot be more than 30 characters"),
  stopWord: Yup.string()
    .max(20, "Stop word cannot be more than 20 characters")
    .required("Please enter stop word")
    .matches(
      noSpaceAtTheBeginning,
      "Stop word cannot begin with space character"
    ),
  title: Yup.string()
    .required("Title is required")
    .matches(
      noEndlessSpaces,
      "Only one space character is allowed between words"
    )
    .max(70, "Title cannot be more than 70 characters"),
};

export default values;
